import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { ModalController, NavController } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-help-info',
    templateUrl: './help-info.component.html',
    styleUrls: ['./help-info.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class helpInfoComponent implements OnInit {

    faInfoCircle = faInfoCircle;
    
    constructor(
        private modalController: ModalController,
        private navCtrl: NavController
    ) {}

    ngOnInit() {/* empty */}

    ctaClick() {
        this.modalController.dismiss({ success: true });
    }

    dismiss() {
        this.modalController.dismiss();
    }
}
